export class MenuTab {
    /**
     * @param {string} name
     * @param {boolean} isActive
     */
    constructor(name, isActive) {
        this._name = name;
        this._isActive = isActive;
    }

    /**
     * @returns {string}
     */
    get name() {
        return this._name;
    }

    /**
     * @param value
     */
    set name(value) {
        this._name = value;
    }

    /**
     * @returns {boolean}
     */
    get isActive() {
        return this._isActive;
    }

    /**
     * @param value
     */
    set isActive(value) {
        this._isActive = value;
    }
}